import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=ed55ff74&scoped=true"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetail.vue?vue&type=style&index=0&id=ed55ff74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed55ff74",
  null
  
)

export default component.exports